import { CommonConfigurations } from "../models/index.js";
import { CryptoService } from "../services/index.js";
import { PulseRootConfigurationToken } from "./tokens.js";
export function coreProviders(builder) {
    return builder
        .useFactory(CommonConfigurations, (config) => config, [PulseRootConfigurationToken])
        .useClass(CryptoService, CryptoService, []);
}
//# sourceMappingURL=providers.js.map